import { Injectable } from '@angular/core';
import { TaskCost } from './taskcost';
import { APISCockpit } from 'src/service/apis-cockpit';
import { TaskItem } from '../../taskcommon/taskcommon.class';

const API = '/api/construction-projects/v1/cockpit-taskcosts/';

@Injectable({ providedIn: 'root' })
export class TaskCostService {

  taskcost: TaskCost = new TaskCost();
  taskCosts: TaskCost[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoTask(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.taskCosts = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskCosts.length > 0) {
        this.taskcost = this.taskCosts[0];
      }
    }
    return this.taskcost;
  }

  async GetInfoTaskByInput(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/byinput/' + itm.inputId;
      this.taskCosts = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskCosts.length > 0) {
        this.taskcost = this.taskCosts[0];
      }
    }
    return this.taskcost;
  }

}
